import { OpenFeature } from "@openfeature/react-sdk";

function isWebdriverCookieSet() {
  return /(?:^|;\s*)webdriver=/.test(document.cookie);
}

export function returnFalseIfRunningViaAutomation() {
  const isInMemoryProvider =
    import.meta.env.REACT_APP_FLAG_PROVIDER === "in-memory";
  const providerClient = OpenFeature.getProviderForClient();
  const flagProvider =
    providerClient?.providerEntriesByName?.["in-memory"];
  const isAutomated = navigator?.webdriver || isWebdriverCookieSet();
  const isNavigatorWebdriver = navigator?.webdriver;

  if (isInMemoryProvider || flagProvider?.name === "in-memory") {
    return isAutomated ? "false" : "true";
  } else {
    return isNavigatorWebdriver ? "false" : "true";
  }
}

export function isAutomateTest() {
  // Following envs are localhost or dev
  return (
    (import.meta.env.REACT_APP_TEST_ENV === "true" ||
      import.meta.env.NODE_ENV === "development") &&
    (navigator?.webdriver || isWebdriverCookieSet())
  );
}